module.exports = __webpack_public_path__ + "static/media/hillshade_prepare.fragment.86deaf42.glsl";